import { useRouter } from "next/router"
import React from "react"
import { Company } from "../types"

interface CompanyTableRowProps {
  company: Company
}

export const CompanyTableRow: React.FC<CompanyTableRowProps> = ({ company }) => {
  const router = useRouter()

  const handleRowClick = () => {
    // 行クリックで詳細ページへ遷移
    router.push(`/admin/companies/${company.id}`)
  }

  return (
    <tr
      className="cursor-pointer border-b border-gray-200 transition-colors hover:bg-gray-50"
      onClick={handleRowClick}
    >
      {/* ID */}
      <td className="px-4 py-3 text-center align-middle text-[1.6rem] font-bold text-gray-900">
        {company.id}
      </td>

      {/* 会社名 */}
      <td className="px-4 py-3 align-middle text-[1.6rem] font-bold text-gray-900">
        <div className="truncate" title={company.name}>
          {company.name}
        </div>
      </td>

      {/* メールアドレス */}
      <td className="px-4 py-3 align-middle text-[1.6rem] text-gray-900">
        <div className="truncate" title={company.email}>
          {company.email}
        </div>
      </td>

      {/* 店舗数 */}
      <td className="px-4 py-3 text-center align-middle text-[1.6rem] font-bold text-gray-900">
        {company.storesCount}
      </td>
    </tr>
  )
}
